<template>
  <v-row class="pa-0 ma-0">
    <!-- Imagen grande en dialog -->
    <v-dialog v-model="showImageDialog" max-width="90%">
      <v-card class="pa-0" tile>
        <!-- Botón de cerrar (arriba a la derecha) -->
        <v-btn
          icon
          color="red"
          class="close-btn"
          @click="showImageDialog = false"
          style="position: absolute; top: 10px; right: 10px; z-index: 10"
        >
          <v-icon>fa-times</v-icon>
        </v-btn>

        <!-- Imagen completa -->
        <v-img :src="selectedImage" contain max-height="90vh"></v-img>
      </v-card>
    </v-dialog>

    <v-card class="chat-container ma-0 pa-0 fill-height">
      <v-card-title class="chat-header">
        <v-avatar size="40" class="mr-3" rounded color="grey lighten-2">
          <v-img src="@/assets/no_logo_user.png"></v-img>
        </v-avatar>
        <div>
          <div class="font-weight-bold">{{ numero }}</div>
        </div>
        <v-spacer></v-spacer>
      </v-card-title>

      <v-card-text class="messages-container pa-0" ref="msgWrapper">
        <div class="messages-wrapper">
          <div
            v-for="(message, index) in messages"
            :key="index"
            :class="[
              'message-bubble',
              message.externalSender ? 'my-message' : 'their-message',
            ]"
          >
            <div class="message-content">
              <!-- AUDIOS -->
              <audio
                v-if="message.messageType == 'audio'"
                :src="`${baseURL}/api/MetaAPI/download-media?mediaID=${message.mediaID}`"
                controls
              ></audio>
              <!-- TEXTOS -->
              <span
                v-if="
                  message.messageType == 'text' ||
                  message.messageType == 'template' ||
                  message.messageType == 'button'
                "
              >
                {{ message.text }}
              </span>
              <!-- IMAGENES -->
              <div
                style="position: relative; display: inline-block"
                v-if="message.messageType == 'image'"
              >
                <v-img
                  contain
                  width="250"
                  @click="openImage(message)"
                  :src="`${baseURL}/api/MetaAPI/download-media?mediaID=${message.mediaID}`"
                ></v-img>

                <!-- Botón de descarga -->
                <v-btn
                  x-small
                  text
                  fab
                  color="primary"
                  :href="`${baseURL}/api/MetaAPI/download-media?mediaID=${message.mediaID}`"
                  download
                  style="position: absolute; bottom: 8px; right: 8px"
                >
                  <v-icon class="px-0 mx-0"> fas fa-download </v-icon>
                </v-btn>
              </div>
              <!-- VIDEOS -->
              <video controls v-if="message.messageType == 'video'" width="250">
                <source
                  :src="`${baseURL}/api/MetaAPI/download-media?mediaID=${message.mediaID}`"
                />
              </video>
              <!-- DOCUMENTOS -->
              <div v-if="message.messageType == 'document'">
                <v-btn
                  :href="`${baseURL}/api/MetaAPI/download-media?mediaID=${message.mediaID}`"
                  download
                  class="px-0 py-6 d-flex align-center text-none"
                  color="white"
                  outlined
                  block
                  style="border-radius: 12px"
                >
                  <v-icon large class="mr-3" color="blue darken-2"
                    >fa-file-download</v-icon
                  >

                  <div class="flex-grow-1 text-left">
                    <div
                      class="subtitle-2 font-weight-medium blue--text text--darken-2"
                    >
                      {{ message.mediaID || "Documento" }}
                    </div>
                    <div class="grey--text text--darken-1 caption">
                      Archivo disponible para descargar
                    </div>
                  </div>
                </v-btn>
              </div>
              <!-- LOCATION -->
              <div
                v-if="message.messageType == 'location'"
                style="
                  width: 100%;
                  height: 250px;
                  border-radius: 12px;
                  overflow: hidden;
                "
              >
                <iframe
                  width="100%"
                  height="100%"
                  :src="`https://www.google.com/maps?q=${message.latitud},${message.longitud}&hl=es&z=15&output=embed`"
                  frameborder="0"
                  allowfullscreen
                >
                </iframe>
              </div>
            </div>
            <div class="message-time">
              <span>
                {{ formatTime(message.timestamp) }}
              </span>
              <div
                v-if="message.estado"
                style="width: 40px; display: flex; gap: 0.1px"
              >
                <v-icon
                  v-if="message.estado === 'sent'"
                  small
                  color="grey lighten-1"
                  class="pa-0 ma-0"
                  style="width: 6px"
                >
                  far check
                </v-icon>
                <v-icon
                  v-if="message.estado === 'sent'"
                  small
                  color="grey lighten-1"
                  class="pa-0 ma-0"
                  style="width: 6px"
                >
                  far check
                </v-icon>

                <v-icon
                  v-if="message.estado === 'delivered'"
                  small
                  color="grey lighten-1"
                  class="pa-0 ma-0"
                  style="width: 6px"
                >
                  far check
                </v-icon>
                <v-icon
                  v-if="message.estado === 'delivered'"
                  small
                  color="grey lighten-1"
                  class="pa-0 ma-0"
                  style="width: 6px"
                >
                  far check
                </v-icon>

                <v-icon
                  v-if="message.estado === 'read'"
                  small
                  color="primary"
                  class="pa-0 ma-0"
                  style="width: 6px"
                >
                  far check
                </v-icon>
                <v-icon
                  v-if="message.estado === 'read'"
                  small
                  color="primary"
                  class="pa-0 ma-0"
                  style="width: 6px"
                >
                  far check
                </v-icon>
              </div>
            </div>
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="numeroReenvio"
                  icon
                  x-small
                  fab
                  color="primary"
                  @click="resendMessage(message)"
                  style="position: absolute; top: 0px"
                  :style="
                    message.externalSender ? 'left: -30px;' : 'right: -30px;'
                  "
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>fas fa-share-square</v-icon>
                </v-btn>
              </template>
              <span>Enviar a proveedor</span>
            </v-tooltip>
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="message-input-container">
        <!-- <v-btn icon>
          <v-icon>fas fa-paperclip</v-icon>
        </v-btn> -->

        <template v-if="!historico">
          <template v-if="messages.length == 0">
            <v-combobox
              v-model="selectedPlantilla"
              :items="nombresPlantillas"
              item-text="Nombre"
              item-value="Nombre"
              hide-details
              dense
              auto-select-first
              outlined
            ></v-combobox>

            <v-btn
              icon
              :disabled="!selectedPlantilla"
              @click="sendMessage"
              color="primary"
            >
              <v-icon>fas fa-paper-plane</v-icon>
            </v-btn>
          </template>
          <template v-else>
            <div class="message-input-container">
              <v-text-field
                v-show="!showFileInput"
                v-model="newMessage"
                placeholder="Escribe un mensaje"
                outlined
                @keyup.enter="sendMessage"
                dense
                hide-details
                class="message-input"
              ></v-text-field>
              <v-file-input
                v-show="showFileInput"
                v-model="filesMessage"
                label="Subir Archivos"
                multiple
                dense
                hide-details
                small-chips
                class="message-input-file"
                outlined
              ></v-file-input>
              <v-btn
                icon
                @click="showFileInput = !showFileInput"
                color="primary"
              >
                <v-icon v-if="!showFileInput">fas fa-paperclip</v-icon>
                <v-icon v-else>fas fa-times-circle</v-icon>
              </v-btn>
              <v-tooltip top color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-if="numeroAsistencia && !numeroReenvio"
                    icon
                    color="primary"
                    @click="setTemplateMessage"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>far fa-list-alt</v-icon>
                  </v-btn>
                </template>
                <span>Plantilla Cliente</span>
              </v-tooltip>

              <v-btn
                icon
                :disabled="
                  newMessage.trim().length == 0 && filesMessage.length == 0
                "
                @click="sendMessage"
                color="primary"
              >
                <v-icon>fas fa-paper-plane</v-icon>
              </v-btn>
            </div>
          </template>
        </template>
      </v-card-actions>
    </v-card>
  </v-row>
</template>

<script>
import Axios from "axios";
import MensajeClienteMixin from "../../mixins/MensajeClienteMixin";
const signalR = require("@microsoft/signalr");

export default {
  mixins: [MensajeClienteMixin],
  name: "WhatsAppChat",
  props: {
    numeroAsistencia: {
      type: String,
    },
    numero: {
      type: String,
      default: true,
    },
    numeroReenvio: {
      type: String,
    },
    historico: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      enviandoMensaje: false,
      messages: [],
      newMessage: "",
      showFileInput: false,
      filesMessage: [],
      showImageDialog: false,
      selectedImage: null,
      tipoAsistencia: "GRUA LIVIANA",
      poliza: "258703",
      proveedor: "REGIONAL EIGHT",
      linkBoleta: "2025208564?c=31a18ebb-6e50-4274-9dca-8d706b9aa9e9",
      nombresPlantillas: [],
      selectedPlantilla: null,
      templates: [
        {
          name: "encuesta_sisa",
          previous_category: "UTILITY",
          parameter_format: "POSITIONAL",
          components: [
            {
              type: "BODY",
              text: "Hola, {{1}}! tengo el gusto con *{{2}}*. \nLe saluda *{{3}}* de SISA asistencia; queremos hacerle un atento recordatorio a nuestra encuesta y agradecerle por utilizar nuestro servicio. Además, conocer su grado de satisfacción por medio de una breve encuesta.",
              example: {
                body_text: [["Buenas tardes", "JUANA PEREZ", "JUAN PEREZ"]],
              },
            },
            {
              type: "BUTTONS",
              buttons: [
                {
                  type: "URL",
                  text: "Realizar encuesta",
                  url: "https://www.asistenciaregional.com/Sisa/Encuesta/{{1}}",
                  example: [
                    "https://www.asistenciaregional.com/Sisa/Encuesta/203599",
                  ],
                },
              ],
            },
          ],
          language: "es",
          status: "APPROVED",
          category: "MARKETING",
          sub_category: "CUSTOM",
          id: "2255586278254617",
        },
        {
          name: "encuesta",
          parameter_format: "POSITIONAL",
          components: [
            {
              type: "BODY",
              text: "Estimado(a):\nSe le notifica que su servicio de *{{1}}*, bajo la póliza *{{2}}*, será atendido por *{{3}}*. Estamos atentos a su servicio\n\nAyúdenos a seguir mejorando. Por favor, cuando el servicio haya finalizado, ingrese al siguiente link 👇 y complete la boleta electrónica.",
              example: {
                body_text: [["GRUA LIVIANA", "P1294S2", "JUAN PEREZ"]],
              },
            },
            {
              type: "BUTTONS",
              buttons: [
                {
                  type: "URL",
                  text: "Boleta Electrónica",
                  url: "https://asistenciaregional.com/Boleta/{{1}}",
                  example: [
                    "https://asistenciaregional.com/Boleta/2025207456?c=a3ae4155-161c-4144-9d07-055fa26fa39c",
                  ],
                },
              ],
            },
          ],
          language: "en",
          status: "APPROVED",
          category: "UTILITY",
          id: "745722397928037",
        },
        {
          name: "hello_world",
          parameter_format: "POSITIONAL",
          components: [
            {
              type: "HEADER",
              format: "TEXT",
              text: "Hello World",
            },
            {
              type: "BODY",
              text: "Welcome and congratulations!! This message demonstrates your ability to send a WhatsApp message notification from the Cloud API, hosted by Meta. Thank you for taking the time to test with us.",
            },
            {
              type: "FOOTER",
              text: "WhatsApp Business Platform sample message",
            },
          ],
          language: "en_US",
          status: "APPROVED",
          category: "UTILITY",
          id: "1205062904833658",
        },
      ],
    };
  },
  created() {
    this.getPlantillasWA();
    this.checkMessages();
  },
  watch: {
    numero(newVal, oldVal) {
      if (oldVal) {
        this.leaveChat(oldVal);
      }
      if (newVal) {
        this.joinChat(newVal);
      }

      this.checkMessages();
    },
    historico() {
      this.checkMessages();
    },
  },
  computed: {
    baseURL() {
      return process.env.VUE_APP_AXIOS;
    },
    normalizedNumero() {
      return this.numero?.replace(/\D/g, "");
    },
  },
  mounted() {
    this.createConnection();
  },
  async beforeDestroy() {
    if (this.numero) {
      await this.leaveChat(this.normalizedNumero);
    }

    if (this.hubConnection) {
      this.hubConnection.off("ReceiveMessage");
      await this.hubConnection.stop();
      this.hubConnection = null;
    }
  },
  methods: {
    setTemplateMessage() {
      this.newMessage = this.MensajeSMSCliente();
    },
    async createConnection() {
      if (this.hubConnection) return;

      this.hubConnection = new signalR.HubConnectionBuilder()
        .withAutomaticReconnect()
        .withUrl(process.env.VUE_APP_AXIOS + "/ChatsWA", {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
        })
        .build();

      this.hubConnection.on("ReceiveMessage", (message) => {
        this.onReceiveMessage(message);
      });

      this.hubConnection.onreconnected(async () => {
        console.log("Reconnected");
        if (this.numero) {
          await this.joinChat(this.normalizedNumero);
        }
      });

      await this.hubConnection.start();
      console.log("Conectado a WhatsApp");

      if (this.numero) {
        await this.joinChat(this.normalizedNumero);
      }
    },
    onReceiveMessage(message) {
      if (message.waId != null) {
        const index = this.messages.findIndex((m) => m.waId == message.waId);

        if (index === -1) {
          if (message.estado == null || message.estado == "accepted") {
            this.messages.push(message);
          }
        } else {
          this.messages[index].estado = message.estado;
        }
      }

      this.$nextTick(() => {
        this.$refs.msgWrapper?.scrollTo({
          top: this.$refs.msgWrapper.scrollHeight,
          behavior: "smooth",
        });
      });

      setTimeout(() => {
        this.$store.commit("MARK_AS_READ", message.numero);
      }, 1000);
    },
    async joinChat(num) {
      if (this.hubConnection?.state === signalR.HubConnectionState.Connected) {
        await this.hubConnection.invoke("JoinChat", num);
      }
    },
    async leaveChat(num) {
      if (this.hubConnection?.state === signalR.HubConnectionState.Connected) {
        await this.hubConnection.invoke("LeaveChat", num);
      }
    },
    resendMessage(message) {
      if (!this.numeroReenvio) return;
      let apiRequest = {
        messaging_product: "whatsapp",
        recipient_type: "individual",
        to: this.numeroReenvio,
        type: message.messageType,
      };

      if (message.messageType != "text") {
        if (message.messageType == "location") {
          apiRequest[message.messageType] = {
            latitude: message.latitud,
            longitude: message.longitud,
          };
        } else {
          apiRequest[message.messageType] = {
            id: message.mediaID,
          };
        }
      } else {
        apiRequest[message.messageType] = {
          body: message.text,
        };
      }

      this.sendMediaMessage(apiRequest);
    },
    openImage(message) {
      this.selectedImage = `${this.baseURL}/api/MetaAPI/download-media?mediaID=${message.mediaID}`;
      this.showImageDialog = true;
    },
    async getMedia(mediaID) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      Axios.get(`/api/download-media?mediaID=${mediaID}`, configuracion)
        .then((res) => {
          const blob = res.blob();

          return URL.createObjectURL(blob);
        })
        .catch((err) => console.error(err));
    },
    plantillaEncuesta(msj) {
      return {
        messaging_product: "whatsapp",
        to: this.normalizedNumero,
        type: "template",
        hubConnection: null,
        template: {
          name: "encuesta",
          language: {
            code: "en",
          },
          components: [
            {
              type: "body",
              parameters: [
                {
                  type: "text",
                  text: this.tipoAsistencia,
                },
                {
                  type: "text",
                  text: this.poliza,
                },
                {
                  type: "text",
                  text: this.proveedor,
                },
              ],
            },
            {
              type: "button",
              sub_type: "url",
              index: "0",
              parameters: [
                {
                  type: "text",
                  text: this.linkBoleta,
                },
              ],
            },
          ],
        },
        mensaje: {
          mensaje: msj,
        },
        numero_asistencia: this.numeroAsistencia,
      };
    },
    plantillaInicio(msj) {
      return {
        messaging_product: "whatsapp",
        to: this.normalizedNumero,
        type: "template",
        template: {
          name: "inicio",
          language: {
            code: "en",
          },
          components: [
            {
              type: "body",
            },
            {
              type: "button",
              sub_type: "quick_reply",
              index: 0,
            },
          ],
        },

        mensaje: {
          mensaje: msj,
        },
        numero_asistencia: this.numeroAsistencia,
      };
    },
    checkMessages() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      let url = `api/MetaAPI/check-messages?numero=${this.normalizedNumero}`;

      if (this.historico) {
        url += "&historico=true";
      }

      //ACTUALIZAR NUMERO DE ASISTENCIA SI EXISTE
      if (this.numeroAsistencia) {
        this.setNumeroAsistencia(this.numeroAsistencia);
        this.buscarNumeroAsistencia(this.$store.state.token);
      }

      Axios.get(url, configuracion)
        .then((res) => {
          this.messages = res.data;

          this.$nextTick(() => {
            this.$refs.msgWrapper?.scrollTo({
              top: this.$refs.msgWrapper.scrollHeight,
              behavior: "smooth",
            });
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    reemplazarPlaceholders(texto, valores) {
      return texto.replace(/\{\{(\d+)\}\}/g, (match, numero) => {
        const index = parseInt(numero) - 1;
        return valores[index] !== undefined ? valores[index] : match;
      });
    },
    sendMessage() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      if (this.messages.length == 0) {
        //ENVIAR TEMPLATE
        if (this.enviandoMensaje) return;
        if (this.selectedPlantilla) {
          this.enviandoMensaje = true;
          switch (this.selectedPlantilla.Nombre) {
            case "inicio":
              const msj = this.selectedPlantilla.Texto;

              this.message = Axios.post(
                "api/MetaAPI/send-template",
                this.plantillaInicio(msj),
                configuracion
              )
                .then((res) => {})
                .catch((err) => {
                  console.error(err);
                })
                .finally(() => {
                  this.enviandoMensaje = false;
                });

              break;
            // case "encuesta":
            //   const valores = [
            //     this.tipoAsistencia,
            //     this.poliza,
            //     this.proveedor,
            //   ];
            //   const msj = this.reemplazarPlaceholders(
            //     this.selectedPlantilla.Texto,
            //     valores
            //   );

            //   this.message = Axios.post(
            //     "api/MetaAPI/send-template",
            //     this.plantillaEncuesta(msj)
            //   )
            //     .then((res) => {})
            //     .catch((err) => {
            //       console.error(err);
            //     });
            //   break;

            default:
              break;
          }
        }
      } else {
        //ENVIAR MENSAJE NORMAL
        if (!this.showFileInput) {
          // MENSAJE DE TEXTO

          if (this.newMessage.trim().length == 0) {
            return;
          }

          let apiRequest = {
            messaging_product: "whatsapp",
            recipient_type: "individual",
            to: this.normalizedNumero,
            type: "text",
            text: {
              preview_url: false,
              body: this.newMessage,
            },
          };

          Axios.post("api/MetaAPI/send-message", apiRequest, configuracion)
            .then((res) => {
              this.newMessage = "";
            })
            .catch((err) => console.error(err));
        } else {
          // MENSAJE MULTIMEDIA
          this.subirArchivos();
        }
      }

      this.enviandoMensaje = false;
    },
    async subirArchivos() {
      const formData = new FormData();

      this.filesMessage.forEach((file, index) => {
        formData.append("archivos", file);
      });

      try {
        const response = await Axios.post(
          "api/MetaAPI/upload-media",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        );

        const mediaIDs = response.data;

        for (const mediaID of mediaIDs) {
          let apiRequest = {
            messaging_product: "whatsapp",
            recipient_type: "individual",
            to: this.normalizedNumero,
            type: mediaID.tipo,
          };

          apiRequest[mediaID.tipo] = {
            id: mediaID.id,
          };

          await this.sendMediaMessage(apiRequest);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.newMessage = "";
        this.filesMessage = [];
        this.showFileInput = false;
      }
    },
    async sendMediaMessage(apiRequest) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      await Axios.post(
        "api/MetaAPI/send-message",
        apiRequest,
        configuracion
      ).catch((err) => console.error(err));
    },
    getPlantillasWA() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      Axios.get("api/MetaAPI/templates", configuracion)
        .then((res) => {
          this.templates = res.data.data;
          // this.nombresPlantillas = this.templates
          //   .filter((t) => t.name != "hello_world")
          //   .map((t) => {
          //     return {
          //       Nombre: t.name,
          //       Id: t.id,
          //       Texto: t.components[0].text,
          //     };
          //   });

          this.nombresPlantillas = this.templates
            .filter((t) => t.name == "inicio")
            .map((t) => {
              return {
                Nombre: t.name,
                Id: t.id,
                Texto: t.components[0].text,
              };
            });
        })
        .catch((err) => console.error(err));
    },
    formatTime(timestamp) {
      if (!timestamp) return "";

      const date = new Date(timestamp);
      return date.toLocaleString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },
  },
};
</script>

<style scoped>
.chat-container {
  height: max(600px, calc(100vh - 48px));
  display: flex;
  flex-direction: column;
  /* max-width: 90%; */
  width: 100%;
}

.chat-header {
  background-color: #f0f0f0;
  border-bottom: 1px solid #e0e0e0;
  padding: 0.775rem 1rem;
}

.messages-container {
  flex: 1;
  overflow-y: auto;
  background-color: #e5ddd5;
}

.messages-wrapper {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.message-bubble {
  max-width: 70%;
  padding: 8px 12px;
  border-radius: 8px;
  position: relative;
  word-wrap: break-word;
}

.my-message {
  align-self: flex-end;
  background-color: #dcf8c6;
  border-bottom-right-radius: 2px;
}

.their-message {
  align-self: flex-start;
  background-color: #ffffff;
  border-bottom-left-radius: 2px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.message-content {
  margin-bottom: 4px;
  line-height: 1.4;
}

.message-time {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 0.7rem;
  color: #667781;
  text-align: right;
  margin-top: 2px;
}

.their-message .message-time {
  text-align: left;
}

.message-input-container {
  background-color: #f0f0f0;

  display: flex;
  width: 100%;
  gap: 0.5rem;
  align-items: center;
}

.message-input {
  background-color: white;
}

.message-input-file::v-deep .v-input__slot {
  background-color: #ffffff !important;
}

/* Scrollbar personalizado */
.messages-container::-webkit-scrollbar {
  width: 6px;
}

.messages-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.messages-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.messages-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>